export const getItemValue = (el: any) => {
    const value = el.value;
    return value === undefined ? el.textContent || "" : value;
};

export const generateText = (opts: any[], value: any | any[]) => {
    if (value === undefined) {
        return "";
    }
    if (Array.isArray(value)) {
        return value
            .map((v) => textForValue(opts, v))
            .filter((opt) => opt !== null)
            .join(", ");
    } else {
        return textForValue(opts, value) || "";
    }
};

export const textForValue = (opts: any[], value: any): string | null => {
    const option = opts.find((opt) => getItemValue(opt) === value);

    // a list item can have "multiline" support, which means two lines of content
    // in these cases we only want the text content of the slot for the primary text.
    if (option && option.hasAttribute("multiline")) {
        const textNode = option.querySelector("[slot='primary']");
        return textNode ? textNode.textContent : null;
    }
    return option ? option.textContent : null;
};
